import { useState } from "react";
import Modal from "../../common/Modal";
import { TriangleAlert } from "lucide-react";

function ArchiveLegislationModal({ isOpen, onClose, legislation, onArchive }) {
  const [remarks, setRemarks] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onArchive(legislation, remarks);
    setRemarks("");
    onClose();
  };

  const handleCancel = () => {
    setRemarks("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            Proceed
          </button>
        </div>
      }
      size="2xl"
    >
      <div className="px-6">
        <div className="flex justify-center mb-4">
          <TriangleAlert style={{ width: "50px", height: "50px", color: "blue" }} />

        </div>

        <h2 className="text-xl font-semibold text-gray-900 text-center mb-3">
          Archive this legislation?
        </h2>

        <div className="text-center text-gray-600 mb-6 space-y-2">
          <p>This legislation and its related records (resolutions and ordinances) will be moved to the archives.</p>
          <p>You can restore it anytime from the archive list.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="remarks" className="block text-sm font-medium text-gray-700 mb-2">
              Remarks
            </label>
            <textarea
              id="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Remarks"
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default ArchiveLegislationModal;